import { registerSW } from "virtual:pwa-register";

/**
 * Service Worker registration is best-effort. It is rejected by bot crawlers
 * (Googlebot, Google-Read-Aloud), private-browsing modes, restrictive proxies
 * that mangle the SW MIME type, and storage-disabled environments. None of
 * these are actionable, so we swallow the rejection and only log to the
 * console — keeping it out of Sentry entirely.
 */
export const registerServiceWorker = (): void => {
  if (!("serviceWorker" in navigator)) return;

  registerSW({
    immediate: true,
    onRegisterError: (error: unknown) => {
      console.warn("Service Worker registration failed:", error);
    },
  });
};
